import React from 'react';
import { Linkedin, Youtube, Instagram } from 'lucide-react';
import { SOCIAL } from '../../data/content';

const ITEMS = [
  { key: 'linkedin', Icon: Linkedin, href: SOCIAL.linkedin, label: '/parthsharma1011', hover: 'hover:text-[#0A66C2]' },
  { key: 'youtube', Icon: Youtube, href: SOCIAL.youtube, label: '@beardandbinary', hover: 'hover:text-[#FF0000]' },
  { key: 'instagram', Icon: Instagram, href: SOCIAL.instagram, label: '@beardandbinary', hover: 'hover:text-[#E1306C]' },
];

export function SocialIconRow({ size = 18, className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {ITEMS.map(({ key, Icon, href, label, hover }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          title={label}
          aria-label={`${key} ${label}`}
          data-testid={`nav-social-${key}`}
          className={`text-white/50 transition-all duration-200 hover:scale-110 ${hover}`}
        >
          <Icon size={size} strokeWidth={1.75} />
        </a>
      ))}
    </div>
  );
}

export function SocialListCard() {
  return (
    <div className="flex flex-col gap-1">
      {ITEMS.map(({ key, Icon, href, label, hover }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`social-card-${key}`}
          className="group flex items-center justify-between py-3 px-2 border-b border-white/5 transition-all hover:pl-4"
        >
          <div className="flex items-center gap-3">
            <Icon size={18} className={`text-white/60 transition-colors ${hover}`} strokeWidth={1.75} />
            <span className="font-mono text-xs tracking-wide text-white/80 group-hover:text-teal">{label}</span>
          </div>
          <span className="text-white/30 group-hover:text-teal transition-colors">→</span>
        </a>
      ))}
    </div>
  );
}
